import React from "react";
import ReactDOM from "react-dom/client";
import { Rnd } from "react-rnd";
import ProfileContent from "./ProfileContent.jsx";

// Global counters (module-level)
let TOP_Z = 10000; // starting point above your base
let OPEN_SEQ = 0;  // optional: open order counter

function nowIso() {
  return new Date().toISOString();
}

function bringToFront(modalContainer) {
  TOP_Z += 1;
  modalContainer.style.zIndex = String(TOP_Z);

  // Update "last focused" timestamp
  modalContainer.dataset.lastFocusedAt = nowIso();
}

function openFloatingModal(id, content, position) {
  const modalId = `floating-modal-content-${id}`;

  // Create container once
  let modalContainer = document.getElementById(modalId);
  if (!modalContainer) {
    modalContainer = document.createElement("div");
    modalContainer.id = modalId;
    modalContainer.className = "floating-modal";
    modalContainer.style.position = "fixed";
    modalContainer.style.top = "7.5%";
    modalContainer.style.left = "7.5%";
    modalContainer.style.transform = "translate(-50%, -50%)";

    // Base z-index; will be bumped immediately below
    modalContainer.style.zIndex = String(TOP_Z);

    // Timestamp + open metadata
    OPEN_SEQ += 1;
    modalContainer.dataset.openedAt = nowIso();
    modalContainer.dataset.openSeq = String(OPEN_SEQ);

    // Bring to front on pointerdown (capture = true)
    // This will also fire when you click inside the Rnd / header, etc.
    modalContainer.addEventListener(
      "pointerdown",
      () => bringToFront(modalContainer),
      true
    );

    document.body.appendChild(modalContainer);
  }

  // Always bring to front when "opened" is called
  bringToFront(modalContainer);

  // Build modal content
  const floatingModal = (
    <Rnd
      default={{ x: 0, y: 0, width: "85vw", height: "85vh" }}
      dragHandleClassName="modal-header"
      cancel=".modal-header details, .modal-header button, .modal-header a, .modal-header [data-cancel-drag]"
      style={{
        color: "white",
        backgroundColor: "#101010",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
        borderRadius: "8px",
        position: "absolute",
        border: "2px solid #ccc",
        // zIndex should be controlled by the container div; keep Rnd neutral
      }}
      // Optional: if you want dragging to also “focus” it:
      onDragStart={() => bringToFront(modalContainer)}
      onResizeStart={() => bringToFront(modalContainer)}
    >
      <ProfileContent
        modalId={modalId}
        id={id}
        content={content}
        position={position}
        // Pass timestamps if you want to display them in header:
        openedAt={modalContainer.dataset.openedAt}
        lastFocusedAt={modalContainer.dataset.lastFocusedAt}
        openSeq={modalContainer.dataset.openSeq}
      />
    </Rnd>
  );

  const modalRoot = ReactDOM.createRoot(modalContainer);
  modalRoot.render(floatingModal);
}

export default openFloatingModal;
